import type { PlanDuration } from '@weft/types';
import { UnlimitedDurationSchema } from '@weft/types';
import type { Dayjs } from '@weft/utils';

export function getLastContractDay(startDate: Dayjs, duration: PlanDuration) {
  if (duration < -1) {
    throw new Error('Invalid plan duration');
  }

  return UnlimitedDurationSchema.safeParse(duration).success
    ? undefined
    : startDate
      .add(duration, 'month')
      .subtract(1, 'day')
      .endOf('day');
}